var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.65332,
    width: 70.6533,
    height: 70.6533,
    rx: 12,
    fill: "#FFEED0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6246 19.8046H22.5854C20.6966 19.8046 19.1512 21.3499 19.1512 23.2387V47.2779C19.1512 49.1667 20.6966 50.7121 22.5854 50.7121H46.6246C48.5134 50.7121 50.0587 49.1667 50.0587 47.2779V23.2387C50.0587 21.3499 48.5134 19.8046 46.6246 19.8046ZM29.4537 43.8437H26.0196V31.8241H29.4537V43.8437ZM36.3221 43.8437H32.8879V26.6729H36.3221V43.8437ZM43.1904 43.8437H39.7562V36.9754H43.1904V43.8437Z",
    fill: "#FFAA15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.703ee0ea3ba324699a7e05c9e1192e75.svg";
export { ForwardRef as ReactComponent };